import { createSlice } from '@reduxjs/toolkit';

const INITIAL_SEARCHPARAMS_SATATE = {
    firstName: null,
    lastName: null,
    email: null,
    pickupCode: null,
    reservationCode: null
};

const INITIAL_REZ_STATE = {
    reservationId: null,
    firstName: null,
    lastName: null,
    reservationCode: null,
    pickupOffice: null,
    pickupDateTime: null,
    returnDateTime: null,
}

const initialState ={
    searchParams: INITIAL_SEARCHPARAMS_SATATE,
    dataResult: [],
    selectedRez: INITIAL_REZ_STATE
};

export const searchRezSlice = createSlice({
    name: 'searchRez',
    initialState,
    reducers: {
        resetSearch: () => initialState,
        setSearchResult: (state, { payload } ) => {
            state.dataResult = payload;
        },
        setSearchCodeParams: (state, { payload } ) => {
            state.searchParams.reservationCode = payload.reservationCode;
        },
        setSearchNoCodeParams: (state, { payload } ) => {
            state.searchParams.firstName = payload.firstName;
            state.searchParams.lastName = payload.lastName;
            state.searchParams.email = payload.email;
        },
        updateAttributeByName: (state, { payload }) => {
            state.searchParams[payload.name] = payload.value;
        },
        setCurrentRez: (state, { payload }) => {
            state.selectedRez = payload ?? INITIAL_REZ_STATE;
        },
    }
});


// Action creators are generated for each case reducer function
export const { resetSearch, updateAttributeByName, setSearchResult, setSearchCodeParams, setSearchNoCodeParams, setCurrentRez } = searchRezSlice.actions;
